import React from 'react';

const StatsCard = ({ title, value, icon, color, change }) => {
  const getColorClasses = (color) => {
    switch (color) {
      case 'blue':
        return 'text-blue-600 bg-blue-100';
      case 'green':
        return 'text-green-600 bg-green-100';
      case 'purple':
        return 'text-purple-600 bg-purple-100';
      case 'yellow':
        return 'text-yellow-600 bg-yellow-100';
      default:
        return 'text-gray-600 bg-gray-100';
    }
  };

  return (
    <div className="bg-white rounded-lg shadow p-4 sm:p-6">
      <div className="flex items-start gap-3 sm:items-center">
        <div className={`flex-shrink-0 p-3 rounded-full ${getColorClasses(color)}`}>
          {icon}
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium text-gray-500 break-words">{title}</p>
          <div className="mt-1 flex flex-col gap-1 sm:flex-row sm:items-baseline">
            <p className="text-xl font-semibold text-gray-900 break-words sm:text-2xl">{value}</p>
            {change && (
              <p className="text-sm font-medium text-green-600">
                {change}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
